import { TextView } from '@dreryk/react-components';
import { createTranslatedText, Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { PaymentMethodType } from '../types';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentMethodTypeTextViewProps = Readonly<{ paymentMethodType: PaymentMethodType | null | undefined }>;

export const AdvancePaymentMethodTypeTextView = (props: AdvancePaymentMethodTypeTextViewProps): JSX.Element => {
   return (
      <TextView testId={'advancePaymentMethod'} label={translationKeys.advancePaymentMethodType}>
         <Translate>
            {props.paymentMethodType
               ? translationKeys.paymentMethodTypeMap[props.paymentMethodType]
               : createTranslatedText(EMPTY_PLACEHOLDER)}
         </Translate>
      </TextView>
   );
};
